export async function executeWithTimeout<T>(action: Promise<any>, timeoutMessage: string, ms: number) {
  const timedOut = new Promise((reject) => { setTimeout(reject, ms, new Error('timeout')); });
  let result: T;

  await Promise.race([action, timedOut])
    .then(r => {
      if (r instanceof Error && r.message === 'timeout') {
        // standalone utility function - no DI available, Logger cannot be injected here
        console.error(timeoutMessage);
      }
      else {
        result = r as T;
      }
    });

  return result;
}

export function delay(ms: number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
